import type { CodeObjectV2 } from "@bezpart-board/shared";
import { nextZIndex } from "../../editor/zIndex";
import { CODE_DEFAULTS } from "./codeLogic";

export const CODE_DEFAULT_SIZE = { w: 580, h: 500 } as const;

/** Виджет «Код», центрированный в (cx, cy). */
export function createCodeObject(
  cx: number,
  cy: number,
  existingObjects: { zIndex?: string }[] = []
): CodeObjectV2 {
  const { w, h } = CODE_DEFAULT_SIZE;
  const d = CODE_DEFAULTS;
  return {
    id: crypto.randomUUID(),
    type: "code",
    x: Math.round(cx - w / 2),
    y: Math.round(cy - h / 2),
    w,
    h,
    language: d.language,
    source: d.source,
    html: d.html,
    css: d.css,
    js: d.js,
    stdout: d.stdout,
    zIndex: nextZIndex(existingObjects),
  };
}
